<template>
    <v-app>
        <v-main>
            <div class="portal-login" :style="cssVars">
              <div class="portal-login__bg">
                <img src="@/assets/background.jpg" :alt="`${schoolName} campus`" class="portal-login__bg-img" />
                <div class="portal-login__vignette" />
              </div>
          
              <header class="portal-login__topbar">
                <div class="portal-login__brand">
                  <img  src="@/assets/logo.png" :alt="`${schoolName} crest`" class="portal-login__crest" />
                  <span class="portal-login__brand-name">{{ schoolName }}</span>
                </div>
                
              </header>
          
              <main class="portal-login__stage">
                <section class="portal-login__card" role="form" aria-labelledby="portal-login-heading">
                  <p class="portal-login__eyebrow">{{ eyebrow }}</p>
                  <h1 id="portal-login-heading" class="portal-login__heading">
                    Welcome back<span class="portal-login__heading-dot">.</span>
                  </h1>
          
                  <!-- report-card divider: a rising term-by-term marks trend -->
                    <svg class="portal-login__vine" viewBox="0 0 220 26" preserveAspectRatio="none" aria-hidden="true">
                    <line x1="2" y1="24" x2="218" y2="24" stroke="currentColor" stroke-width="1" opacity="0.35" />
                    <rect
                      v-for="(bar, i) in gradeBars"
                      :key="bar.x"
                      class="portal-login__grade-bar"
                      :style="{ animationDelay: `${i * 90}ms` }"
                      :x="bar.x"
                      :y="24 - bar.h"
                      width="10"
                      :height="bar.h"
                      rx="1.5"
                      fill="currentColor"
                      opacity="0.55"
                    />
                    <path
                      class="portal-login__trend-line"
                      :d="trendPath"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <circle
                      v-for="(pt, i) in trendPoints"
                      :key="pt.x"
                      class="portal-login__trend-dot"
                      :style="{ animationDelay: `${560 + i * 70}ms` }"
                      :cx="pt.x"
                      :cy="pt.y"
                      r="2.1"
                      fill="currentColor"
                    />
                    <circle
                      v-if="trendPoints.length"
                      class="portal-login__live-ring"
                      :cx="trendPoints[trendPoints.length - 1].x"
                      :cy="trendPoints[trendPoints.length - 1].y"
                      r="2.1"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1"
                    />
                  </svg>
           
          
                  <p class="portal-login__sub">
                    Sign in to accesss term reports and marks.
                  </p>
          
                  <div class="portal-login__form">
                    <label class="portal-login__field mb-4">
                      <span class="portal-login__field-label">Birth Certificate Pin</span>
                      <!-- <input
                        v-model="form.birth_certificate_pin"
                        type="text"
                        autocomplete="username"
                        class="portal-login__input"
                       
                        placeholder="10 Digits"
                        @blur="touched = true"
                      /> -->
                      <v-text-field
                        v-model="formData.birth_certificate_pin"
                        dense
                        dark
                        placeholder="10 Digits"
                        outlined
                        class="date-of-birth"
                        hide-details
                      ></v-text-field>
                    </label>
          
                    <label class="portal-login__field mb-4">
                      <span class="portal-login__field-label">Date of Birth</span>
                        <!-- <input
                          v-model="form.date_of_birth"
                          class="portal-login__input"
                          :class="{ 'portal-login__input--error': touched && !form.password }"
                          placeholder="yyyy-mm-dd"
                          @blur="touched = true"
                        /> -->
                          <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                          >
                              <template v-slot:activator="{on, attrs}">
                                  <v-text-field
                                      v-model="formData.date_of_birth"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      hide-details
                                      outlined
                                      class="date-of-birth"
                                      dark
                                      dense
                                      placeholder="yyyy-mm-dd"
                                  ></v-text-field>
                              </template>
                              <v-date-picker
                                  v-model="formData.date_of_birth"
                                  :active-picker.sync="activePicker"
                                  :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)"
                                  min="1950-01-01"
                                  @change="save"
                              ></v-date-picker>
                          </v-menu>
                        
                    </label>
          
                    <p v-if="errorMessage" class="portal-login__error" role="alert">{{ errorMessage }}</p>
          
                    <div class="portal-login__actions">
                      <v-btn
                        type="submit"
                        rounded
                        depressed
                        color="primary"
                        class="portal-login__submit"
                        @click="submit"
                        block
                      >
                        Sign in
                      </v-btn>
                    </div>
                </div>

                  <v-overlay
                    :value="overlay"
                    opacity="0.8"
                    z-index="10"                    
                >
                    
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>                   
                </v-overlay>
                </section>
              </main>
            </div>
        </v-main>
    </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'Login',

  data() {
    return {
      formData: {
        birth_certificate_pin: '',
        date_of_birth: '',
      },
      showPassword: false,
      touched: false,
      gradeBars: [
        { x: 4, h: 10 },
        { x: 48, h: 14 },
        { x: 92, h: 12 },
        { x: 136, h: 18 },
        { x: 180, h: 21 },
      ],
      eyebrow: "PARENT & STUDENT REPORT PORTAL",
      loading: false,
      errorMessage: null,
      accentColor: '#3F6B3F',
      activePicker: null,
      date: null,
      menu: false,
      overlay: false,
    }
  },

  watch: {
    menu(val){
        val && setTimeout(() => {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        })
    }
  },

  computed: {
    ...mapGetters({
        schoolName: 'auth/getSchoolName',            
        getAuthenticated: 'auth/getAuthenticated',            
    }), 
    cssVars() {
      return {
        '--accent': this.accentColor,
      }
    },

    trendPoints() {
      return this.gradeBars.map((bar) => ({
        x: bar.x + 5,
        y: 24 - bar.h - 3,
      }))
    },
    trendPath() {
      return this.trendPoints
        .map((pt, i) => `${i === 0 ? 'M' : 'L'} ${pt.x} ${pt.y}`)
        .join(' ')
    },
  },

  methods: {
    ...mapActions({
        signIn: 'auth/signIn', 
    }),

    ...mapMutations({
        setOverlay: 'auth/setOverlay',
        setCredentials: 'auth/setCredentials',
        setStudentRecord : 'auth/setStudentRecord',
        setAuthenticated: 'auth/setAuthenticated',
        setAuthToken: 'auth/setAuthToken',
    }),    
    async submit() {
        this.overlay = true;
        console.log(this.formData)
        try{
            this.setCredentials(this.formData)
            const { data } = await this.signIn();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.auth_token;
            
            sessionStorage.setItem('auth_token', data.auth_token);
            sessionStorage.setItem('studentRecord',JSON.stringify(data));
            sessionStorage.setItem('authenticated', data.id);
            
            this.setStudentRecord(data);
            this.setAuthenticated(data.id);
            this.setAuthToken(data.auth_token);

            this.$router.replace('/term-report');
        } catch (error){
            error.response ? console.log(error.response) : error
        } finally {
            this.overlay = false;
        }
    },

    save(date){
        this.$refs.menu.save(date)
    }
  },
}
</script>

<style scoped>
.portal-login {
  --ink: #1a2e1c;
  --cream: #f5f1e6;
  --oxide: #8b2e2e;
  --brass: #c9a15a;
  --accent: #3f6b3f;
  position: relative;
  min-height: 100vh;
  width: 100%;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  overflow: hidden;
}

.portal-login__bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}
.portal-login__bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: saturate(0.92) contrast(1.02);
}
.portal-login__vignette {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(15, 22, 16, 0.55) 0%, rgba(15, 22, 16, 0.35) 30%, rgba(15, 22, 16, 0.75) 100%),
    linear-gradient(90deg, rgba(15, 22, 16, 1) 0%, rgba(15, 22, 16, 0.65) 35%, rgba(15, 22, 16, 0.05) 100%);
}

.portal-login__topbar {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 40px;
}
.portal-login__brand {
  display: flex;
  align-items: center;
  gap: 10px;
}
.portal-login__crest {
  width: 60px;
  height: 60px;
  object-fit: contain;
}
.portal-login__brand-name {
  color: var(--cream);
  font-weight: 600;
  letter-spacing: 0.02em;
  font-size: 15px;
}
.portal-login__nav {
  display: flex;
  gap: 28px;
}
.portal-login__nav-link {
  color: var(--cream);
  text-decoration: none;
  font-size: 13.5px;
  letter-spacing: 0.03em;
}
.portal-login__nav-link--muted {
  opacity: 0.65;
}

.portal-login__stage {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  min-height: calc(90vh - 40px);
  padding: 20px clamp(20px, 6vw, 96px);
}

.portal-login__card {
  width: 100%;
  max-width: 400px;
  /* background: rgba(26, 30, 22, 0.62);
  border: 1px solid rgba(245, 241, 230, 0.14);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-radius: 20px; */
  padding: 40px 36px 32px;
  /* box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35); */
}

.portal-login__eyebrow {
  margin: 0 0 10px;
  font-size: 11px;
  letter-spacing: 0.16em;
  color: var(--brass);
  font-weight: 600;
  text-transform: uppercase;
}

.portal-login__heading {
  margin: 0;
  font-family: 'Fraunces', Georgia, 'Times New Roman', serif;
  font-weight: 500;
  font-size: 34px;
  line-height: 1.1;
  color: var(--cream);
}
.portal-login__heading-dot {
  color: var(--oxide);
}

.portal-login__vine {
  width: 100%;
  height: 16px;
  color: var(--brass);
  opacity: 0.7;
  margin: 14px 0 16px;
}

.portal-login__grade-bar {
  transform-box: fill-box;
  transform-origin: bottom;
  transform: scaleY(0);
  animation-name: portal-login-bar-grow, portal-login-bar-pulse;
  animation-duration: 0.5s, 2.6s;
  animation-timing-function: cubic-bezier(0.22, 1, 0.36, 1), ease-in-out;
  animation-fill-mode: forwards, none;
  animation-iteration-count: 1, infinite;
  animation-direction: normal, alternate;
}
 
.portal-login__trend-line {
  stroke-dasharray: 300;
  stroke-dashoffset: 300;
  animation: portal-login-line-draw 0.55s ease-out 0.5s forwards;
}
 
.portal-login__trend-dot {
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center;
  transform: scale(0);
  animation: portal-login-dot-pop 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}
 
.portal-login__live-ring {
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center;
  animation: portal-login-live-ring 2.2s ease-out 1.15s infinite;
}
 
@keyframes portal-login-bar-grow {
  to {
    transform: scaleY(1);
  }
}
@keyframes portal-login-bar-pulse {
  0%,
  100% {
    opacity: 0.55;
  }
  50% {
    opacity: 0.85;
  }
}
@keyframes portal-login-line-draw {
  to {
    stroke-dashoffset: 0;
  }
}
@keyframes portal-login-dot-pop {
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes portal-login-live-ring {
  0% {
    transform: scale(1);
    opacity: 0.65;
  }
  100% {
    transform: scale(2.8);
    opacity: 0;
  }
}
 
@media (prefers-reduced-motion: reduce) {
  .portal-login__grade-bar,
  .portal-login__trend-line,
  .portal-login__trend-dot,
  .portal-login__live-ring {
    animation: none;
    transform: none;
    stroke-dashoffset: 0;
    opacity: 1;
  }
  .portal-login__live-ring {
    opacity: 0;
  }
}
 

.portal-login__sub {
  margin: 0 0 26px;
  font-size: 13.5px;
  line-height: 1.5;
  color: rgba(245, 241, 230, 0.75);
}
.portal-login__link {
  color: var(--brass);
  font-weight: 600;
  text-decoration: none;
}
.portal-login__link:hover {
  text-decoration: underline;
}

.portal-login__form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.portal-login__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.portal-login__field-label {
  font-size: 11.5px;
  letter-spacing: 0.04em;
  color: rgba(245, 241, 230, 0.6);
  text-transform: uppercase;
}

.v-input.date-of-birth{
    border: 1px solid rgba(245, 241, 230, 0.18);
    background: rgba(245, 241, 230, 0.06);
    border: 1px solid rgba(245, 241, 230, 0.18);
    border-radius: 10px;
    font-size: 14.5px;
}

.portal-login__input {
  width: 100%;
  box-sizing: border-box;
  background: rgba(245, 241, 230, 0.06);
  border: 1px solid rgba(245, 241, 230, 0.18);
  border-radius: 10px;
  padding: 12px 14px;
  color: var(--cream);
  font-size: 14.5px;
  outline: none;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.portal-login__input::placeholder {
  color: rgba(245, 241, 230, 0.35);
}
.portal-login__input:focus {
  border-color: var(--accent);
  background: rgba(245, 241, 230, 0.1);
}
.portal-login__input--error {
  border-color: var(--oxide);
}

.portal-login__input-wrap {
  position: relative;
}
.portal-login__input-wrap .portal-login__input {
  padding-right: 42px;
}
.portal-login__reveal {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: rgba(245, 241, 230, 0.55);
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 6px;
}
.portal-login__reveal:hover {
  color: var(--cream);
}

.portal-login__error {
  margin: 0;
  font-size: 12.5px;
  color: #e2a0a0;
}

.portal-login__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 6px;
}

.portal-login__ghost {
  background: transparent;
  border: none;
  color: rgba(245, 241, 230, 0.6);
  font-size: 12.5px;
  cursor: pointer;
  padding: 8px 4px;
}
.portal-login__ghost:hover {
  color: var(--cream);
}

.portal-login__submit {
  /* background: var(--accent);
  color: var(--cream); */
  border: none;
  border-radius: 999px;
  padding: 12px 26px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  min-width: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: filter 0.15s ease, transform 0.1s ease;
}
.portal-login__submit:hover:not(:disabled) {
  filter: brightness(1.1);
}
.portal-login__submit:active:not(:disabled) {
  transform: translateY(1px);
}
.portal-login__submit:disabled {
  opacity: 0.7;
  cursor: default;
}

.portal-login__spinner {
  width: 15px;
  height: 15px;
  border: 2px solid rgba(245, 241, 230, 0.4);
  border-top-color: var(--cream);
  border-radius: 50%;
  animation: portal-login-spin 0.7s linear infinite;
}
@keyframes portal-login-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 560px) {
  .portal-login__topbar {
    padding: 20px 20px;
  }
  .portal-login__card {
    max-width: 100%;
    padding: 32px 24px 26px;
  }
  .portal-login__heading {
    font-size: 28px;
  }
}
</style>
